import { Order } from '@/entities/orders/models/Order'
import { GridTableDragType } from '@/shared/components/GridTable/models/GridTableDragType'
import { faEarth } from '@fortawesome/pro-solid-svg-icons'

import { PlanningInboxGridRow } from '../model/planning/PlanningInboxGridRow'

export const getInboxRowFromOrder = (order: Order): PlanningInboxGridRow => {
  const isPickup = order.isPickup
  const customerLocation = isPickup ? order.fromLocation : order.toLocation
  const depotLocation = isPickup ? order.toLocation : order.fromLocation

  // Parse service time
  const serviceTimeStr = isPickup ? order.serviceTimePickup : order.serviceTimeDelivery
  const serviceTime = serviceTimeStr ? parseFloat(serviceTimeStr) : 0

  const inboxRow: PlanningInboxGridRow = {
    id: order.id,
    scenarios: order.scenarios || [],

    // Grid Table Row Props
    isDraggable: true,
    isDroppable: false,
    isSelectable: true,
    hasHotAction: true,
    hasActions: true,
    textHighlight: false,
    dragType: GridTableDragType.INBOX_ORDER_ROW,
    acceptDropTypes: [GridTableDragType.SHIFT_STOP_ROW, GridTableDragType.UNASSIGNED_ORDER_ROW],

    // Inbox Order Details Row
    orderId: order.id,
    orderNumber: order.orderNumber,
    preferredDateOfOperation: order.preferredDateOfOperation,
    orderType: isPickup ? 'Pickup' : 'Delivery',
    weight: order.weight,
    volume: order.volume,
    orderQuantity: order.quantity,
    timeWindows: order.timeWindows,
    serviceTime: serviceTime,
    priority: order.priority,
    maxOnboardTime: order.maxOnboardTime,
    tripNumber: order.tripNumber,
    consignmentNumber: order.consignmentNumber || '',
    description: order.description,
    deliveryInstruction: order.deliveryInstruction || '',
    comment: order.comment || '',

    // Customer Address Details Row
    isGeocoded: customerLocation?.isGeocoded || false,
    geocodeError: customerLocation?.isGeocoded ? undefined : {
      tooltipText: 'Order not geocoded',
      type: 'warning',
      icon: faEarth,
    },
    customerAddress: customerLocation.displayAddress,
    customerSuburb: customerLocation.suburb,
    customerState: customerLocation.state,
    customerPostcode: customerLocation.postcode,
    customerMapRef: customerLocation.mapRef || '',
    customerAdditional: customerLocation.additional || '',

    customerNumber: customerLocation.externalId || '',
    customerName: customerLocation.name || '',

    // Depot Details Row
    depotCode: depotLocation.externalId || '',
    depotName: depotLocation.name || '',
  }

  return inboxRow
}